"use strict";
var HandlerInfo = require("../handler-info")["default"];
var resolveHook = require("../utils").resolveHook;
var merge = require("../utils").merge;
var subclass = require("../utils").subclass;
var promiseLabel = require("../utils").promiseLabel;

// Generated by URL transitions and non-dynamic route segments in named Transitions.
var UnresolvedHandlerInfoByParam = subclass (HandlerInfo, {
  initialize: function(props) {
    this.params = props.params || {};
  },

  getModel: function(payload) {
    var fullParams = this.params;
    if (payload && payload.queryParams) {
      fullParams = {};
      merge(fullParams, this.params);
      fullParams.queryParams = payload.queryParams;
    }

    var handler = this.handler;
    var hookName = resolveHook(handler, 'deserialize') ||
                   resolveHook(handler, 'model');

    return this.runSharedModelHook(payload, hookName, [fullParams]);
  }
});

exports["default"] = UnresolvedHandlerInfoByParam;